import { render } from "./createPublicComponent.vue?vue&type=template&id=13e84b7f&scoped=true"
import script from "./createPublicComponent.vue?vue&type=script&lang=js"
export * from "./createPublicComponent.vue?vue&type=script&lang=js"

import "./createPublicComponent.vue?vue&type=style&index=0&id=13e84b7f&lang=less"
import "./createPublicComponent.vue?vue&type=style&index=1&id=13e84b7f&lang=css"
import "./createPublicComponent.vue?vue&type=style&index=2&id=13e84b7f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e84b7f"]])

export default __exports__